import t from "../locales";
import voedselImage from "../assets/images/voedsel.png";
import smaakImage from "../assets/images/smaakpapillen.png";
import plantImage from "../assets/images/planten.png";
import leerkrachtImage from "../assets/images/leerkracht.png";
import stemrechtImage from "../assets/images/stemrecht.png";
import robotbabysImage from "../assets/images/robotbabys.png";

const CATEGORIES = {
  voeding: {
    slug: "voeding",
    // Falls back to the category-less VITE_COLLECTOR_KEY/VITE_AGGREGATOR_KEY so
    // existing deployments keep working before per-category keys are set.
    // TODO: Remove fallbacks after the new implementation hits production
    collectorKey:
      import.meta.env.VITE_COLLECTOR_KEY_VOEDING ??
      import.meta.env.VITE_COLLECTOR_KEY,
    aggregatorKey:
      import.meta.env.VITE_AGGREGATOR_KEY_VOEDING ??
      import.meta.env.VITE_AGGREGATOR_KEY,
    header: {
      title: t("categories.voeding.header.title"),
    },
    dashboard: {
      heading: t("categories.voeding.dashboard.heading"),
      description: t("categories.voeding.dashboard.description"),
    },
    fragments: {
      smaakpapillen: {
        title: t("categories.voeding.fragments.smaakpapillen.title"),
        image: smaakImage,
      },
      planten: {
        title: t("categories.voeding.fragments.planten.title"),
        image: plantImage,
      },
      voedsel: {
        title: t("categories.voeding.fragments.voedsel.title"),
        image: voedselImage,
      },
    },
    perspectives: [
      "boeren",
      "jonge_kinderen",
      "kunstenaars",
      "ouders",
      "politici",
      "chefkoks",
      "wetenschappers",
      "onszelf",
    ],
    ages: [
      "prehistorisch",
      "robot",
      "viking",
      "industriele_revolutie",
      "jaar_2100",
      "middeleeuwse_periode",
      "jaren_negentig",
      "vandaag",
    ],
    posters: [
      "/posters/AdobeStock_1151301869.jpeg",
      "/posters/AdobeStock_1230587241.jpeg",
      "/posters/AdobeStock_1383068620.jpeg",
      "/posters/AdobeStock_1398929095.jpeg",
      "/posters/AdobeStock_15760050.jpeg",
      "/posters/AdobeStock_1604898202.jpeg",
      "/posters/AdobeStock_1614948042.jpeg",
      "/posters/AdobeStock_1636716771.jpeg",
      "/posters/AdobeStock_1691317428.jpeg",
      "/posters/AdobeStock_1732227186.jpeg",
      "/posters/AdobeStock_278277109.jpeg",
      "/posters/AdobeStock_301184266.jpeg",
      "/posters/AdobeStock_366379668.jpeg",
      "/posters/AdobeStock_474565424.jpeg",
      "/posters/AdobeStock_559938246.jpeg",
      "/posters/AdobeStock_733514217.jpeg",
    ],
  },
  robotics: {
    slug: "robotics",
    collectorKey: import.meta.env.VITE_COLLECTOR_KEY_ROBOTICS,
    aggregatorKey: import.meta.env.VITE_AGGREGATOR_KEY_ROBOTICS,
    header: {
      title: t("categories.robotics.header.title"),
    },
    dashboard: {
      heading: t("categories.robotics.dashboard.heading"),
      description: t("categories.robotics.dashboard.description"),
    },
    fragments: {
      dummy_2: {
        title: t("categories.robotics.fragments.dummy_2.title"),
        image: stemrechtImage,
      },
      dummy_1: {
        title: t("categories.robotics.fragments.dummy_1.title"),
        image: leerkrachtImage,
      },
      dummy_3: {
        title: t("categories.robotics.fragments.dummy_3.title"),
        image: robotbabysImage,
      },
    },
    perspectives: [
      "wetenschappers",
      "politici",
      "bejaarden",
      "jonge_kinderen",
      "werkzoekenden",
      "tieners",
      "leerkrachten",
      "onszelf",
    ],
    ages: [
      "prehistorisch",
      "robot",
      "viking",
      "industriele_revolutie",
      "jaar_2100",
      "middeleeuwse_periode",
      "jaren_negentig",
      "vandaag",
    ],
    posters: [
      "/posters/robotics/AdobeStock_1686585713.jpeg",
      "/posters/robotics/AdobeStock_182059557.jpeg",
      "/posters/robotics/AdobeStock_1885362325.jpeg",
      "/posters/robotics/AdobeStock_202180846.jpeg",
      "/posters/robotics/AdobeStock_255471552.jpeg",
      "/posters/robotics/AdobeStock_289549566.jpeg",
      "/posters/robotics/AdobeStock_310566420.jpeg",
      "/posters/robotics/AdobeStock_332463649.jpeg",
      "/posters/robotics/AdobeStock_462040594.jpeg",
    ],
  },
};

export default CATEGORIES;
